import {ReactElement, ReactNode} from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Box} from '@mui/material';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import useScrollTrigger from '@mui/material/useScrollTrigger';

type ScrollTopProps = {
  children: ReactNode;
  anchorId: string;
};

function ScrollTop({children}: ScrollTopProps): ReactElement {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  function handleClick() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 'fab'
        }}
      >
        {children}
      </Box>
    </Zoom>
  );
}

type BackToTopProps = {
  anchorId: string;
};

export default function BackToTop(props: BackToTopProps): ReactElement {
  return (
    <ScrollTop {...props}>
      <Fab color="primary" size="large" aria-label="scroll back to top">
        <KeyboardArrowUpIcon />
      </Fab>
    </ScrollTop>
  );
}
